import React from 'react';

// Month options for the dropdown (Tháng 1 - Tháng 12)
const MONTHS = [
  { value: '01', label: 'Tháng 1' },
  { value: '02', label: 'Tháng 2' },
  { value: '03', label: 'Tháng 3' },
  { value: '04', label: 'Tháng 4' },
  { value: '05', label: 'Tháng 5' },
  { value: '06', label: 'Tháng 6' },
  { value: '07', label: 'Tháng 7' },
  { value: '08', label: 'Tháng 8' },
  { value: '09', label: 'Tháng 9' },
  { value: '10', label: 'Tháng 10' },
  { value: '11', label: 'Tháng 11' },
  { value: '12', label: 'Tháng 12' },
];

// Returns current year and previous year options
const getYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return [
    { value: String(currentYear), label: String(currentYear) },
    { value: String(currentYear - 1), label: String(currentYear - 1) },
  ];
};

const selectClass =
  'px-2 py-1.5 text-sm border border-gray-300 rounded-lg bg-white ' +
  'focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent ' +
  'text-gray-900 appearance-none cursor-pointer';

/**
 * MonthYearFilter - Compact month/year selector (single row).
 *
 * Props:
 *   selectedMonth  {string} - "01" to "12"
 *   selectedYear   {string} - four-digit year string
 *   onMonthChange  {(value: string) => void}
 *   onYearChange   {(value: string) => void}
 */
const MonthYearFilter = ({ selectedMonth, selectedYear, onMonthChange, onYearChange }) => {
  const yearOptions = getYearOptions();

  return (
    <div className="flex items-center gap-2">
      {/* Month: inline label + select */}
      <div className="flex items-center gap-1.5 flex-1 min-w-0">
        <span className="text-xs font-medium text-gray-500 whitespace-nowrap">Tháng</span>
        <select
          value={selectedMonth}
          onChange={(e) => onMonthChange(e.target.value)}
          className={selectClass + ' flex-1 min-w-0'}
        >
          <option value="">--</option>
          {MONTHS.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </div>

      {/* Year: inline label + select */}
      <div className="flex items-center gap-1.5 flex-1 min-w-0">
        <span className="text-xs font-medium text-gray-500 whitespace-nowrap">Năm</span>
        <select
          value={selectedYear}
          onChange={(e) => onYearChange(e.target.value)}
          className={selectClass + ' flex-1 min-w-0'}
        >
          <option value="">--</option>
          {yearOptions.map((y) => (
            <option key={y.value} value={y.value}>
              {y.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default MonthYearFilter;
